export default __webpack_public_path__ + "static/media/no-image-icon-4.d7790161.png";